import AreaChart from "../../../../components/areaChart/areaChart";
import { connect } from "react-redux";

export function detectInterval(data) {
  let interval = "preserveEnd";
  const length = data.length;
  data.map((item) => {
    if (item.name.indexOf(" - ") > -1) {
      if (data.length === 9) {
        return "preserveStartEnd";
      } else {
        interval = Math.floor(length * 0.15);
      }
    }
  });
  return interval;
}

export default connect((state) => ({
  chartData: state.utilization.graphData.chart_values,
  interval: detectInterval(state.utilization.graphData.chart_values),
  right: 80,
  left: 80,
  width: 1350,
  currencySymbol: state.utilization.chartCurrencySymbol,
  hasRawData: true,
  showDecimals: true,
  hideLegend: true,
  tooltipName: state.utilization.currentSelectedCategory,
  toolTipContent: !!state.utilization.averageTooltip
}))(AreaChart);
